import { betterstartDir } from '@cli-utils/paths.js'

export function ownershipPath(cwd: string): string {
  return betterstartDir(cwd, 'schemas', 'ownership.json')
}
